/**
 * Skeleton Atom
 *
 * A loading placeholder component for content that is loading.
 */

import { cn } from '@/lib/utils';

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('animate-pulse bg-zinc-400/10', className)} {...props} />;
}

export { Skeleton };
